export default "__VITE_ASSET__Cly0m91G__"